import { toTime } from "helpers/dateHelper";
import { useTranslation } from "react-i18next";
import { Avatar, IconButton } from "@mui/material";
import { FaInstagram, FaTrashAlt } from "react-icons/fa";
import { MessageReadIcon } from "components/_Icons/MessageReadIcon";
import { AutomationIcon } from "components/_Icons/AutomationIcon";
import { Link } from "react-router-dom";

interface ChatMessageItemProps {
  message: any;
  chat: any;
  deleteMessage: (id: number) => void;
  sendMessage: (message: string) => void;
}

export const ChatMessageItem = ({ message, chat, deleteMessage, sendMessage }: ChatMessageItemProps) => {
  const { t } = useTranslation();

  const buildMessageBody = () => {
    let replyTo = null;
    if (message.replyTo) {
      replyTo = (
        <div className="message-reply-to">
          <div className="message-reply-to-header">
            <div className="message-reply-to-header-text fs-12 py-2">
              <span>Ответ на историю</span>
            </div>
            <div className="message-reply-to-header-avatar" style={{ width: 150, height: "auto" }}>
              {message.createdAt > new Date().getTime() - 1000 * 60 * 60 * 24 ? (
                <img
                  src={message.replyTo?.story?.url}
                  alt="Reply to"
                  className="w-full h-full"
                  onError={(e) => {
                    e.currentTarget.src = "/placeholder.png";
                  }}
                />
              ) : (
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none",
                    width: "100%",
                    height: "240px",
                    borderRadius: "20px",
                    color: "rgba(60, 60, 67, .72)",
                    border: "1px solid #e5e5e5",
                    textAlign: "center",
                    margin: "0 auto",
                  }}
                >
                  <a href={message.replyTo?.story?.url} target="_blank" rel="noopener noreferrer">
                    <div className="flex flex-col items-center gap-2 justify-center">
                      <FaInstagram />
                      <span>Посмотреть в Instagram</span>
                    </div>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        {replyTo}
        {message?.image && (
          <div className="message-image mb-4 mt-4" style={{ width: "260px", height: "auto" }}>
            <img src={message.image} alt="Message Image" />
          </div>
        )}
        <div
          className={`message-text ${message.senderType}`}
          dangerouslySetInnerHTML={{
            __html: String(message.text).replace(/\n/g, "<br />"),
          }}
        />
        {/* Buttons */}
        <div className="flex flex-col gap-2">
          {message.buttons?.map((button: any) => (
            <div key={button.id} className="message-button">
              <div className="cursor-pointer" onClick={() => {
                console.log("button", button);
                if (button.url.startsWith("http")) {
                  window.open(button.url, "_blank");
                } else {
                  sendMessage(`BUTTON: ${button.text}`);
                }
              }} style={{ color: "#fff", border: "1px solid #fff", padding: "5px 10px", borderRadius: "5px" }}>
                {button.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const buildAvatar = () => {

    let avatar = null;
    if (message.senderType === "user") {
      avatar = chat?.contact?.externalUserPhoto || "/media/images/avatar.png";
    } else if (message.senderType === "assistant") {
      avatar = <AutomationIcon />;
    } else if (message.senderType === "member") {
      avatar = chat?.channelConnection?.externalAccountPhoto || "/media/images/avatar.png";
    }

    return <Avatar src={avatar} alt="Avatar" className="w-10 h-10 rounded-full" />;
  };

  return (
    <div key={message.id} className={`message-wrapper ${message.senderType}`}>
      <div className={`message ${message.senderType}`}>
        <div className="message-sender">
          {message.senderType != "user" ? (
            <>
              <span>
                {chat?.externalAccountFirstName ||
                  chat?.externalAccountUserName ||
                  chat?.externalAccountID}
              </span>
              <span className="ml-2">({t(`senderType.${message.senderType}`)})</span>
            </>
          ) : (
            chat?.contact?.externalUserFirstName || chat?.contact?.externalUserID || t(`senderType.${message.senderType}`)
          )}
        </div>
        {buildMessageBody()}
        <div className="message-time fs-12 text-right flex items-center gap-2 justify-end">
          <span>{toTime(message.createdAt)}</span>
          {/* Message read */}
          {message.read && (
            <div className="message-read justify-end">
              <MessageReadIcon size={12} />
            </div>
          )}
        </div>
      </div>
      <div className="message-actions flex flex-col items-center gap-2">
        {buildAvatar()}
        {/* Удалить сообщение */}
        {chat?.source === "TEST_SANDBOX" && (
          <IconButton onClick={() => deleteMessage(message.id)}>
            <FaTrashAlt size={14} />
          </IconButton>
        )}
      </div>
    </div>
  );
};
